/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevDateRange
 */
export interface DevDateRange {
    /**
     * 
     * @type {Date}
     * @memberof DevDateRange
     */
    from?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DevDateRange
     */
    to?: Date | null;
}

/**
 * Check if a given object implements the DevDateRange interface.
 */
export function instanceOfDevDateRange(value: object): value is DevDateRange {
    return true;
}

export function DevDateRangeFromJSON(json: any): DevDateRange {
    return DevDateRangeFromJSONTyped(json, false);
}

export function DevDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevDateRange {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : (new Date(json['from'])),
        'to': json['to'] == null ? undefined : (new Date(json['to'])),
    };
}

export function DevDateRangeToJSON(json: any): DevDateRange {
    return DevDateRangeToJSONTyped(json, false);
}

export function DevDateRangeToJSONTyped(value?: DevDateRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'] == null ? undefined : (formatDateOnly(value['from'] as any)),
        'to': value['to'] == null ? undefined : (formatDateOnly(value['to'] as any)),
    };
}

